import { AuthFetch } from './api';
import { decryptText } from './crypto';
import { VITE_AUTH0_SECRET_INDEX_KEY } from '../config';
import { IdToken } from '@auth0/auth0-react';
import { ITherapist } from './types';
import { ErrorKey } from '../../../shared/utils/errorKey';

export async function fetchUserAccountRemote(authFetch: AuthFetch): Promise<ITherapist | null> {
  try {
    return await authFetch('/api/v1/user-profile', { method: 'GET' });
  } catch (error: any) {
    if (error?.errorKey === ErrorKey.NoProfileFound) {
      return null;
    }

    throw error;
  }
}

export async function fetchTherapistKey(authFetch: AuthFetch, idToken: IdToken): Promise<string | null> {
  const auth0Key = idToken[VITE_AUTH0_SECRET_INDEX_KEY];
  const keyResponse = await authFetch('/api/v1/chat/key', {
    method: 'GET',
  });
  if (keyResponse && keyResponse.key) {
    return decryptText(auth0Key, keyResponse.key);
  }

  return null;
}
